export default __webpack_public_path__ + "static/media/alert-triangle.6098aab3.svg";